import type { ShowBuffers } from "./showFormat";

/**
 * Off-React storage for the active show's heavy per-frame tracks (position +
 * colour — millions of floats).
 *
 * These are deliberately NOT React state or props. React 19's dev-mode
 * "performance tracks" deep-serialize every component's props/state on each
 * commit; a show passed as a prop made that serialization freeze the tab ~10 s
 * per load/unload. Metadata (`ShowMeta`) flows through React as usual; only the
 * big buffers live here, and only `ShowPlayer` reads them. There is a single
 * active show, so one slot is all we need.
 *
 * `useShowLoader` owns the lifecycle: `set(buffers)` right before it publishes
 * the matching `ShowMeta`, and `set(null)` when the show is closed.
 */
let current: ShowBuffers | null = null;

export const showBuffers = {
  set(buffers: ShowBuffers | null) {
    current = buffers;
  },
  get(): ShowBuffers | null {
    return current;
  },
};
